<div class="loading-shade" *ngIf="isLoading">
	<mat-spinner diameter="80" *ngIf="isLoading"></mat-spinner>
</div>
<form [formGroup]="editSchoolDistrictsForm" class="formEditSchoolDistrict" >
	<span class="forceFloatRight"><button mat-icon-button color="primary" (click)="closeRecord()">
			<span><mat-icon style="transform:translateX(-3px);">close</mat-icon></span>
		</button></span> 
	<mat-card-title><span style="padding-left:18px;font-size:larger;">Edit School Districts</span></mat-card-title>
	<p><br><span class="schoolFont schoolFontDrop" style="padding-left:18px;">{{schoolDistrictName}}</span>&nbsp;&nbsp;
		<span>
			<ng-container *ngIf="!bCancelEdit"><button
				mat-raised-button matTooltipschool="Edit record" (click)="fnEdit()" class="btnRaise" style="padding: 5px;">
				&nbsp;{{editBtnText}}<mat-icon class="iconDisplay">edit</mat-icon>
			</button>
			</ng-container>			
			<ng-container *ngIf="bCancelEdit"><button mat-raised-button matTooltip="Cancel edit"
				(click)="fnCancelEdit()" class="btnRaise">
				<mat-icon class="iconDisplay">close</mat-icon>
				&nbsp;&nbsp;{{editBtnText}}
			</button></ng-container>
		</span></p>
		<mat-tab-group #tabGroup (selectedTabChange)="fnSetSaveButton($event)">
			<mat-tab label="General Info">
				<div class="row">
					<div class="child-1 col-6 halfWidth">
						<mat-card appearance="outlined" class="cardGeneral">
							<mat-card-content>
								<h2>General</h2>
								<div class="form-group">
									<div class="row">
					
										<mat-form-field class="field-full-width" appearance="fill" tabindex="0">
											<mat-label>School District Name</mat-label>

											<input id="schoolDistrictName" 
												[readonly]="isUneditable" 
												formControlName="schoolDName"
												type="text" matInput 
												maxlength="100" 
												class="form-control"
												placeholder="School District Name" 
												pattern="[A-Za-z]"
												[(ngModel)]="schoolDistrictName" 
												>
										</mat-form-field>
									</div>
									<div class="row">
										<mat-form-field class="field-full-width" appearance="fill" tabindex="1">
											<mat-label>School District Code</mat-label>
											<input id="schoolDistrictCode" [readonly]="isUneditable" formControlName="schoolDCode"
												type="text" matInput maxlength="256" class="form-control"
												placeholder="schoolDistrictCode"
												[(ngModel)]="schoolDistrictCode">
										</mat-form-field>
									</div>
									<div class="row">
										<mat-label>School District NCES *</mat-label>
									</div>
									<div class="row">
										<mat-form-field class="field-full-width" appearance="fill" tabindex="2">
											<input id="schoolDistrictNCES" 
												[readonly]="isUneditable" 
												formControlName="schoolDNCES"
												type="text" 
												matInput 
												maxlength="256" 
												class="form-control field-full-width"
												[(ngModel)]="schoolDistrictNCES"
												pattern="[0-9]" 
												>
										</mat-form-field>
									</div>
								</div>
							</mat-card-content>
						</mat-card>
					</div>
				</div>
				<div class="row">
					&nbsp;
				</div>
		
			</mat-tab>
			<mat-tab label="School District Location">
				<div class="row">
					<region-dropdown-two-way id="myRegion" [(selectedRegions)]="chosenRegions" (selectedRegionsChange)="regionEventEmitter($event)" [reset]="resetField"
						[isMultiple]="false" [customLabel]="customRegionLabel" [disabled]="isUneditable" [allowAllRegions]="true" #child2></region-dropdown-two-way>
				</div>
				<div class="row">
					<county-dropdown-two-way id="myCounty1" [reset]="resetField" [(selectedCounties)]="chosenCounties" [regions]="chosenRegions" (selectedCountiesChange)="countiesSelected($event)"
						[isMultiple]="false" [customLabel]="customCountyLabel" [disabled]="isUneditable" #child3></county-dropdown-two-way>
				</div>
			
			</mat-tab>
		</mat-tab-group>
		<p>&nbsp;</p>
		<div class="row">
			<div class="moveRight">
				<ng-container *ngIf="!isUneditable">
					<span styles="position:absolute;float:right; background-color:blue;">
						<ng-container *ngIf="(saveButtonToShow == 'generalinfo')">
							<button type="button" (click)="fnSaveGeneralInfo();" mat-raised-button color="primary"
								(onSubmitErrorEvent)="catchSubmitError($event)">Save</button>&nbsp;&nbsp;
						</ng-container>
						
						<ng-container *ngIf="(saveButtonToShow == 'schooldistrictlocation')">
							<button type="button" (click)="fnSaveSchoolDistrictsLocation();" mat-raised-button color="primary"
								(onSubmitErrorEvent)="catchSubmitError($event)">Save</button>&nbsp;&nbsp;
						</ng-container>
						<mat-icon *ngIf="isLoading && !msg.SUCCESS">
							<mat-spinner *ngIf="isLoading" diameter="20"> </mat-spinner>
						</mat-icon>
						<mat-icon *ngIf="msg.SUCCESS">
							done
						</mat-icon>
						<button mat-raised-button (click)="fnReset()">Reset</button>
						&nbsp;&nbsp;
					</span>
				</ng-container>
			</div>
			<div class="errorMsg">
				<textarea readonly="true" disabled class="errorMsgCtl" id="txtErrorMsg" cols="100">{{myError}}</textarea>
			</div>
			<div>
				<app-msg [msg]="userIdChangedMsg" *ngIf="userIdChangedMsg.MSG"></app-msg>
				<app-msg [msg]="msg"></app-msg>
			</div>
		</div>
</form>
